import React from 'react'

import AssessorGroupCollapse from './AssessorGroupCollapse/AssessorGroupCollapse'

const body = ({
  data = [],
  addRowClicked,
  deleteRowClicked,
  inputChanged,
  collapseClicked,
  dropdownOptions,
  currentCompany,
  currentEmp,
  edit
}) => {
  const groups = data.map(assessorGroup => {
    return (
      <AssessorGroupCollapse
        key={assessorGroup.groupId}
        data={assessorGroup}
        inputChanged={inputChanged}
        addRowClicked={() => addRowClicked(assessorGroup.groupId)}
        deleteRowClicked={deleteRowClicked}
        collapseClicked={() => collapseClicked(assessorGroup.groupId)}
        dropdownOptions={dropdownOptions}
        currentCompany={currentCompany}
        currentEmp={currentEmp}
        edit={edit}
      />
    )
  })
  return groups
}

export default body
